import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Input, EventEmitter, Output, ViewChild, NgModule } from '@angular/core';
import { PrimengLibraryModule } from 'primeng-library';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i3 from '@angular/router';
import * as i4 from 'primeng/dropdown';
import * as i5 from '@angular/forms';
import * as i1$1 from 'primeng/chart';
import * as i7 from 'primeng/multiselect';
import * as i8 from 'primeng/api';
import * as i9 from 'primeng/table';
import * as i10 from 'primeng/checkbox';
import * as i3$1 from 'primeng/button';
import * as i5$1 from '@angular/common';
import * as i2 from 'primeng/dynamicdialog';
import * as i4$1 from 'primeng/accordion';
import * as i5$2 from 'primeng/tree';

class PetitionAnalysisService {
    constructor(http) {
        this.http = http;
    }
    // Petition Analysis
    getSummery(petitionId) {
        return this.http.get(`/analysis/petition/${petitionId}/summary`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getCategorySummary(petitionId) {
        return this.http.get(`/analysis/petition/${petitionId}/categorySummary`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getCategorySummeryOnCategoryCode(petitionId, categoryCode) {
        return this.http.get(`/analysis/petition/${petitionId}/categorySummary?category_code=${categoryCode}`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    getCategoryObervation(petitionId) {
        return this.http.get(`/analysis/petition/${petitionId}/observation`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getCategoryObervationCode(petitionId, categoryCode) {
        return this.http.get(`/analysis/petition/${petitionId}/observation?category_code=${categoryCode}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getPACategoryList() {
        return this.http.get(`/analysis/petition/category`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getPACategory(petitionId) {
        return this.http.get(`/analysis/petition/${petitionId}/category`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    generateAnalysis(petitionId) {
        return this.http.post(`/analysis/petition/${petitionId}/All`, {}).pipe(map((response) => response));
    }
    getPetitionAnalysisStatus(petitionId) {
        return this.http.get(`/analysis/petition/${petitionId}/status`).pipe(map((response) => response));
    }
}
PetitionAnalysisService.ɵfac = function PetitionAnalysisService_Factory(t) { return new (t || PetitionAnalysisService)(i0.ɵɵinject(i1.HttpClient)); };
PetitionAnalysisService.ɵprov = i0.ɵɵdefineInjectable({ token: PetitionAnalysisService, factory: PetitionAnalysisService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PetitionAnalysisService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class PAUtility {
    constructor() {
        this.observationList = [];
    }
    set categoryCode(code) {
        this.selectedCategoryCode = code;
    }
    set categoryName(name) {
        this.selectedCategoryName = name;
    }
    get categoryCode() {
        return this.selectedCategoryCode;
    }
    get categoryName() {
        return this.selectedCategoryName;
    }
    getObservationList() {
        return this.observationList;
    }
    setObservationList(list) {
        this.observationList = list;
    }
}
PAUtility.ɵfac = function PAUtility_Factory(t) { return new (t || PAUtility)(); };
PAUtility.ɵprov = i0.ɵɵdefineInjectable({ token: PAUtility, factory: PAUtility.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PAUtility, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();

class ImgPrimengDonutComponent {
    constructor() { }
    ngOnInit() {
        this.options = {
            tooltips: {
                bodyFontSize: 16,
                callbacks: {
                    label: function (tooltipItem, data) {
                        return `${data.labels[tooltipItem.index]}`;
                    }
                }
            },
            // legend: {
            //   labels : {
            //     fontSize: 16,
            //   },
            //   position: 'bottom',
            //   align: "center",
            // }
            legend: {
                display: true,
                position: "bottom",
                fullWidth: true,
                labels: {
                    boxWidth: 8,
                    fontSize: 14
                }
            },
        };
    }
    ngOnChanges(e) {
        if (e.inputData && e.inputData.currentValue) {
            this.data = e.inputData.currentValue;
        }
    }
}
ImgPrimengDonutComponent.ɵfac = function ImgPrimengDonutComponent_Factory(t) { return new (t || ImgPrimengDonutComponent)(); };
ImgPrimengDonutComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ImgPrimengDonutComponent, selectors: [["img-primeng-donut"]], inputs: { inputData: "inputData" }, features: [i0.ɵɵNgOnChangesFeature], decls: 1, vars: 2, consts: [["type", "doughnut", "height", "300", 3, "options", "data"]], template: function ImgPrimengDonutComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "p-chart", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("options", ctx.options)("data", ctx.data);
    } }, directives: [i1$1.UIChart], styles: [""], changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ImgPrimengDonutComponent, [{
        type: Component,
        args: [{
                selector: 'img-primeng-donut',
                templateUrl: './primeng-donut.component.html',
                styleUrls: ['./primeng-donut.component.scss'],
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { inputData: [{
            type: Input
        }] }); })();

function PaCategorizedComponent_ng_template_30_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-checkbox", 24);
    i0.ɵɵlistener("ngModelChange", function PaCategorizedComponent_ng_template_30_Template_p_checkbox_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.selectAllObservations = $event; })("onChange", function PaCategorizedComponent_ng_template_30_Template_p_checkbox_onChange_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r6 = i0.ɵɵnextContext(); return ctx_r6.handleSelectAll(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r0.selectAllObservations)("binary", true);
} }
function PaCategorizedComponent_ng_template_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 25);
    i0.ɵɵelement(1, "th", 26);
    i0.ɵɵelementStart(2, "th");
    i0.ɵɵtext(3, "Petition Element");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th", 27);
    i0.ɵɵtext(5, "Findings");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th", 27);
    i0.ɵɵtext(7, "Recommendations");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9, "Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function PaCategorizedComponent_ng_template_35_p_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, " Needs to be fixed ");
    i0.ɵɵelementEnd();
} }
function PaCategorizedComponent_ng_template_35_p_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, " Looks Perfect ");
    i0.ɵɵelementEnd();
} }
function PaCategorizedComponent_ng_template_35_p_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, " Not Applicable ");
    i0.ɵɵelementEnd();
} }
function PaCategorizedComponent_ng_template_35_p_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, " Not Initiated ");
    i0.ɵɵelementEnd();
} }
function PaCategorizedComponent_ng_template_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 28);
    i0.ɵɵelement(2, "button", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 30);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 30);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 31);
    i0.ɵɵtemplate(10, PaCategorizedComponent_ng_template_35_p_10_Template, 2, 0, "p", 32);
    i0.ɵɵtemplate(11, PaCategorizedComponent_ng_template_35_p_11_Template, 2, 0, "p", 32);
    i0.ɵɵtemplate(12, PaCategorizedComponent_ng_template_35_p_12_Template, 2, 0, "p", 32);
    i0.ɵɵtemplate(13, PaCategorizedComponent_ng_template_35_p_13_Template, 2, 0, "p", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const obervation_r7 = ctx.$implicit;
    const expanded_r8 = ctx.expanded;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pRowToggler", obervation_r7)("icon", expanded_r8 ? "pi pi-chevron-up" : "pi pi-chevron-down");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(obervation_r7.elementName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(obervation_r7.finding);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(obervation_r7.recommendation);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", obervation_r7.status === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", obervation_r7.status === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", obervation_r7.status === 2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", obervation_r7.status === 3);
} }
function PaCategorizedComponent_ng_template_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 33);
    i0.ɵɵelementStart(1, "td", 34);
    i0.ɵɵelementStart(2, "div", 35);
    i0.ɵɵelementStart(3, "h6");
    i0.ɵɵtext(4, "Findings");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "h6");
    i0.ɵɵtext(8, "Recommendation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const obervation_r13 = ctx.$implicit;
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", obervation_r13.finding, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", obervation_r13.recommendation, " ");
} }
const _c0$2 = function () { return [25, 50, 100]; };
class PaCategorizedComponent {
    constructor(pAService, utilityPAService, route) {
        this.pAService = pAService;
        this.utilityPAService = utilityPAService;
        this.route = route;
        this.observations = [];
        this.selObservationFilterCtg = [];
        this.selectAllObservations = true;
        this.observationCategories = [
            { name: 'Needs to be fixed', code: 0 },
            { name: 'Looks Perfect', code: 1 },
            { name: 'Not Applicable', code: 2 },
            { name: 'Not Initiated', code: 3 }
        ];
        this.onOverAllClick = new EventEmitter();
        this.onPACategoryClick = new EventEmitter();
        this.petitionId = parseInt(sessionStorage.getItem('petitionId'));
    }
    ngOnInit() {
        this.getCategoryList();
        this.handleSelectAll();
    }
    getCategoryObervation() {
        this.pAService.getCategoryObervationCode(this.petitionId, this.categoryCode)
            .subscribe((response) => {
            this.utilityPAService.setObservationList(response.map((x, i) => {
                return Object.assign(Object.assign({}, x), { indexId: i });
            }));
            this.observations = this.utilityPAService.getObservationList();
        });
    }
    getCategoryList() {
        this.pAService.getPACategory(this.petitionId).subscribe((response) => {
            this.categoryList = response;
            this.route.params.forEach((param) => {
                if (param['category']) {
                    this.categoryCode = param['category'];
                    this.loadData();
                }
            });
        });
    }
    loadData() {
        if (this.categoryList.find(x => x.code === this.categoryCode)) {
            this.categoryName = this.categoryList.find(x => x.code === this.categoryCode).name;
            this.getCategoryObervation();
            this.getCategoryChart();
        }
        else {
            this.onOverAllClick.emit();
        }
    }
    onCategorySelect() {
        this.onPACategoryClick.emit({ code: this.categoryCode });
    }
    backToOverallAnalysis() {
        this.onOverAllClick.emit();
    }
    getCategoryChart() {
        this.pAService.getCategorySummeryOnCategoryCode(this.petitionId, this.categoryCode).subscribe((response) => {
            if (response && response.status === 200) {
                this.categoryDetails = response.data;
            }
            else {
                this.categoryDetails = null;
            }
            this.categoryGraphDetails = {
                labels: [`${Math.round((100 * this.categoryDetails.success) / this.categoryDetails.total)}% Looks Perfect`,
                    `${Math.round((100 * this.categoryDetails.failure) / this.categoryDetails.total)}% Needs to be fixed`,
                    `${Math.round((100 * this.categoryDetails.notinitiated) / this.categoryDetails.total)}% Not Initiated`,
                    `${Math.round((100 * this.categoryDetails.na) / this.categoryDetails.total)}% Not Applicable`],
                datasets: [
                    {
                        data: [
                            Math.round((100 * this.categoryDetails.success) / this.categoryDetails.total),
                            Math.round((100 * this.categoryDetails.failure) / this.categoryDetails.total),
                            Math.round((100 * this.categoryDetails.notinitiated) / this.categoryDetails.total),
                            Math.round((100 * this.categoryDetails.na) / this.categoryDetails.total)
                        ],
                        backgroundColor: [
                            "#03A0DA",
                            "#FF8800",
                            "#A3A6B4",
                            "#E1E1E1"
                        ],
                        hoverBackgroundColor: [
                            "#03A0DA",
                            "#FF8800",
                            "#A3A6B4",
                            "#E1E1E1"
                        ]
                    }
                ]
            };
        });
    }
    handleFilter() {
        if (this.selObservationFilterCtg && this.selObservationFilterCtg.length > 0) {
            this.observations = this.utilityPAService.getObservationList().filter((x) => {
                if (this.selObservationFilterCtg.includes(x.status)) {
                    return true;
                }
            });
        }
        else {
            this.observations = [];
        }
        this.togglleAllFilter();
    }
    togglleAllFilter() {
        this.selectAllObservations = this.selObservationFilterCtg.length === this.observationCategories.length ? true : false;
    }
    handleSelectAll() {
        this.selObservationFilterCtg = this.selectAllObservations ? this.observationCategories.map(x => x.code) : [];
        this.handleFilter();
    }
}
PaCategorizedComponent.ɵfac = function PaCategorizedComponent_Factory(t) { return new (t || PaCategorizedComponent)(i0.ɵɵdirectiveInject(PetitionAnalysisService), i0.ɵɵdirectiveInject(PAUtility), i0.ɵɵdirectiveInject(i3.ActivatedRoute)); };
PaCategorizedComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PaCategorizedComponent, selectors: [["app-pa-categorized"]], outputs: { onOverAllClick: "onOverAllClick", onPACategoryClick: "onPACategoryClick" }, decls: 37, vars: 16, consts: [[1, "fluid-container"], [1, "row", "col-md-12", "pa-title"], [1, "row", "col-md-12", "mb-3"], [1, "link", 2, "color", "#8F8F8F", "font", "normal normal normal 14px/18px Source Sans Pro", 3, "click"], [1, "col-md-6", "mb-3"], [1, "col-md-6"], ["optionLabel", "name", "optionValue", "code", 1, "pull-right", 3, "ngModel", "options", "ngModelChange"], [1, "row", "col-md-12", "pa-status"], [1, "pa-brd"], [1, "row", "col-md-12", "pt-4"], [1, "col-md-6", "brd-right"], [3, "inputData"], [1, "pb-4"], [1, "row", "mt-3", "col-md-12", "pa-status"], [1, "col-md-12", "row", 2, "height", "50px"], [1, "col-md-10", "row", "align-items-center"], [1, "col-md-2"], ["optionValue", "code", "defaultLabel", "Filter", "optionLabel", "name", 1, "filter-check", 3, "displaySelectedLabel", "filter", "showToggleAll", "options", "ngModel", "ngModelChange", "onChange"], ["pTemplate", "header"], [1, "col-md-12", "pl-0"], [1, "col", "px-1", "task-table"], ["styleClass", "p-datatable-gridlines", "rowExpandMode", "single", "currentPageReportTemplate", "Showing {first} to {last} of {totalRecords} entries", "dataKey", "indexId", 1, "pa-table", "im-card-no-border-table", "im-card-table-noborder-spacing", "table", 3, "paginator", "rows", "showCurrentPageReport", "rowsPerPageOptions", "value"], ["pTemplate", "body"], ["pTemplate", "rowexpansion"], ["label", "All Observations", "value", "afsdf", 1, "filter-all-select", 3, "ngModel", "binary", "ngModelChange", "onChange"], [1, "text-uppercase"], [2, "width", "3rem"], ["colspan", "2"], [2, "padding-top", "6px!important"], ["type", "button", "pButton", "", "pRipple", "", 1, "p-button-text", "p-button-rounded", "p-button-plain", 3, "pRowToggler", "icon"], ["colspan", "2", 1, "text-truncate"], [1, "text-truncate"], [4, "ngIf"], [1, "pt-5", "pt-5"], ["colspan", "7"], [1, "p-p-3", "rowExpansionData"]], template: function PaCategorizedComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "a", 3);
        i0.ɵɵlistener("click", function PaCategorizedComponent_Template_a_click_3_listener() { return ctx.backToOverallAnalysis(); });
        i0.ɵɵtext(4, " << Back to Petition Analysis");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵelementStart(6, "h5");
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 5);
        i0.ɵɵelementStart(9, "p-dropdown", 6);
        i0.ɵɵlistener("ngModelChange", function PaCategorizedComponent_Template_p_dropdown_ngModelChange_9_listener($event) { return ctx.categoryCode = $event; })("ngModelChange", function PaCategorizedComponent_Template_p_dropdown_ngModelChange_9_listener() { return ctx.onCategorySelect(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 7);
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵelementStart(12, "h6");
        i0.ɵɵtext(13, "Each Category Level Analysis ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 9);
        i0.ɵɵelementStart(15, "div", 10);
        i0.ɵɵelement(16, "img-primeng-donut", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 5);
        i0.ɵɵelementStart(18, "h6", 12);
        i0.ɵɵtext(19, "Overview");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "p");
        i0.ɵɵtext(21);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 13);
        i0.ɵɵelementStart(23, "div", 8);
        i0.ɵɵelementStart(24, "div", 14);
        i0.ɵɵelementStart(25, "div", 15);
        i0.ɵɵelementStart(26, "h6");
        i0.ɵɵtext(27, "Overall Observations");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 16);
        i0.ɵɵelementStart(29, "p-multiSelect", 17);
        i0.ɵɵlistener("ngModelChange", function PaCategorizedComponent_Template_p_multiSelect_ngModelChange_29_listener($event) { return ctx.selObservationFilterCtg = $event; })("onChange", function PaCategorizedComponent_Template_p_multiSelect_onChange_29_listener() { return ctx.handleFilter(); });
        i0.ɵɵtemplate(30, PaCategorizedComponent_ng_template_30_Template, 1, 2, "ng-template", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 19);
        i0.ɵɵelementStart(32, "div", 20);
        i0.ɵɵelementStart(33, "p-table", 21);
        i0.ɵɵtemplate(34, PaCategorizedComponent_ng_template_34_Template, 10, 0, "ng-template", 18);
        i0.ɵɵtemplate(35, PaCategorizedComponent_ng_template_35_Template, 14, 9, "ng-template", 22);
        i0.ɵɵtemplate(36, PaCategorizedComponent_ng_template_36_Template, 11, 2, "ng-template", 23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵtextInterpolate1("", ctx.categoryName, " Details");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngModel", ctx.categoryCode)("options", ctx.categoryList);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("inputData", ctx.categoryGraphDetails);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate(ctx.categoryDetails.overview);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("displaySelectedLabel", false)("filter", false)("showToggleAll", false)("options", ctx.observationCategories)("ngModel", ctx.selObservationFilterCtg);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("paginator", true)("rows", 25)("showCurrentPageReport", true)("rowsPerPageOptions", i0.ɵɵpureFunction0(15, _c0$2))("value", ctx.observations);
    } }, directives: [i4.Dropdown, i5.NgControlStatus, i5.NgModel, ImgPrimengDonutComponent, i7.MultiSelect, i8.PrimeTemplate, i9.Table, i10.Checkbox, i3$1.ButtonDirective, i9.RowToggler, i5$1.NgIf], styles: [".pa-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#585858;font-size:22px;font-weight:600}.pa-title[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#00a3db;font-size:18px;font-weight:600}.pa-status[_ngcontent-%COMP%]   .pa-brd[_ngcontent-%COMP%]{border:1px solid #d3d3d3;width:100%;height:100%;padding:20px}.pa-status[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#888;font-size:21px}.pa-status[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font-size:22px;font-weight:500}.pa-status[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%], .pa-status[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#00a3db;cursor:pointer}.pa-status[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#888;font-size:13px}.brd-right[_ngcontent-%COMP%]{border-right:1px solid #d3d3d3}.pa-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6;padding:15px!important;color:#4d4f5c;font-style:normal;font-variant:normal;font-weight:700;font-size:13px}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{color:#888;border-top:none!important;padding:15px 15px 0!important;font-size:13px}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:6px 8px!important}.mat-table[_ngcontent-%COMP%]   .mat-header-row[_ngcontent-%COMP%]{height:45px}.link[_ngcontent-%COMP%]{cursor:pointer}table.mat-table[_ngcontent-%COMP%]{border-spacing:0}tr.mat-footer-row[_ngcontent-%COMP%], tr.mat-row[_ngcontent-%COMP%]{height:48px}.rowExpansionData[_ngcontent-%COMP%]{width:93%;margin:0 auto;padding:5px 0}.rowExpansionData[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#4d4f5c;font-size:12px;font-style:normal;font-variant:normal;font-weight:700;text-transform:uppercase}.rowExpansionData[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#888;font-size:13px;padding-bottom:20px}"], data: { animation: [
            trigger('rowExpansionTrigger', [
                state('void', style({
                    transform: 'translateX(-10%)',
                    opacity: 0
                })),
                state('active', style({
                    transform: 'translateX(0)',
                    opacity: 1
                })),
                transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
            ])
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaCategorizedComponent, [{
        type: Component,
        args: [{
                selector: 'app-pa-categorized',
                templateUrl: './pa-categorized.component.html',
                styleUrls: ['./pa-categorized.component.scss'],
                animations: [
                    trigger('rowExpansionTrigger', [
                        state('void', style({
                            transform: 'translateX(-10%)',
                            opacity: 0
                        })),
                        state('active', style({
                            transform: 'translateX(0)',
                            opacity: 1
                        })),
                        transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
                    ])
                ]
            }]
    }], function () { return [{ type: PetitionAnalysisService }, { type: PAUtility }, { type: i3.ActivatedRoute }]; }, { onOverAllClick: [{
            type: Output
        }], onPACategoryClick: [{
            type: Output
        }] }); })();

const _c0$1 = ["closebutton"];
function PaLoadComponent_div_3_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const node_r5 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", node_r5.label, " ");
} }
function PaLoadComponent_div_3_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementStart(1, "button", 14);
    i0.ɵɵlistener("click", function PaLoadComponent_div_3_div_11_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.nextPACategoryLoad(ctx_r6.categoryIndex); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function PaLoadComponent_div_3_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵelementStart(1, "button", 16);
    i0.ɵɵlistener("click", function PaLoadComponent_div_3_div_13_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r9); const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.finishPACategoryLoad(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function PaLoadComponent_div_3_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "button", 18);
    i0.ɵɵlistener("click", function PaLoadComponent_div_3_div_14_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(2); return ctx_r10.finishPACategoryLoad(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function PaLoadComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelementStart(1, "h5", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "h5", 5);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p-accordion");
    i0.ɵɵelementStart(6, "p-accordionTab", 6);
    i0.ɵɵelementStart(7, "p-tree", 7);
    i0.ɵɵtemplate(8, PaLoadComponent_div_3_ng_template_8_Template, 1, 1, "ng-template");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 8);
    i0.ɵɵelementStart(10, "div", 9);
    i0.ɵɵtemplate(11, PaLoadComponent_div_3_div_11_Template, 2, 0, "div", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 9);
    i0.ɵɵtemplate(13, PaLoadComponent_div_3_div_13_Template, 2, 0, "div", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, PaLoadComponent_div_3_div_14_Template, 2, 0, "div", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r0.categoryIndex, "/", ctx_r0.listCategory == null ? null : ctx_r0.listCategory.length, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.category.description, "");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("value", ctx_r0.category.children);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.categoryIndex < (ctx_r0.listCategory == null ? null : ctx_r0.listCategory.length));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.categoryIndex < (ctx_r0.listCategory == null ? null : ctx_r0.listCategory.length));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.categoryIndex >= (ctx_r0.listCategory == null ? null : ctx_r0.listCategory.length));
} }
class PaLoadComponent {
    constructor(PAService, ref, dynamicDialogConfig) {
        this.PAService = PAService;
        this.ref = ref;
        this.dynamicDialogConfig = dynamicDialogConfig;
        this.listCategory = [];
        this.categoryIndex = 0;
        this.petitionId = parseInt(sessionStorage.getItem('petitionId'));
    }
    ngOnInit() {
        this.PAService.getPACategory(this.petitionId).subscribe((response) => {
            this.listCategory = response.length > 0 ? response : [];
            this.nextPACategoryLoad(this.categoryIndex);
        });
    }
    setListCategory(itemList) {
        const listItem = [];
        for (let index = 0; index < itemList.length; index++) {
            const item = {
                label: itemList[index].description,
                key: itemList[index].id.toString()
            };
            if (itemList[index].check) {
                item.children = this.setListCategory(itemList[index].check);
            }
            listItem.push(item);
        }
        return listItem;
    }
    nextPACategoryLoad(categoryIndex) {
        this.categoryIndex++;
        this.category = Object.assign(Object.assign({}, this.listCategory[categoryIndex]), { children: this.listCategory[categoryIndex].check && this.listCategory[categoryIndex].check.length > 0 ? this.setListCategory(this.listCategory[categoryIndex].check) : [] });
    }
    finishPACategoryLoad() {
        this.ref.close();
    }
}
PaLoadComponent.ɵfac = function PaLoadComponent_Factory(t) { return new (t || PaLoadComponent)(i0.ɵɵdirectiveInject(PetitionAnalysisService), i0.ɵɵdirectiveInject(i2.DynamicDialogRef), i0.ɵɵdirectiveInject(i2.DynamicDialogConfig)); };
PaLoadComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PaLoadComponent, selectors: [["app-pa-load"]], viewQuery: function PaLoadComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0$1, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.closebutton = _t.first);
    } }, decls: 4, vars: 1, consts: [[1, "fluid-container", "col-md-12"], ["src", "assets/analysisLoaders.gif", 1, "img-responsive"], ["class", "container", 4, "ngIf"], [1, "container"], [1, "review-index"], [1, "review-pa"], ["header", "More Information", 1, "pa-accordian"], [3, "value"], [1, "row"], [1, "col-md-6"], ["class", "col-md-12 text-right", 4, "ngIf"], ["class", "col-md-12 text-left", 4, "ngIf"], ["class", "col-md-12 text-center", 4, "ngIf"], [1, "col-md-12", "text-right"], ["pButton", "", "pRipple", "", "type", "button", "label", "NEXT", "icon", "pi pi-chevron-circle-right", 1, "p-button-outlined", "pa-next-btn", 3, "click"], [1, "col-md-12", "text-left"], ["pButton", "", "pRipple", "", "type", "button", "label", "SKIP", "icon", "pi pi-times-circle", 1, "p-button-outlined", "pa-next-btn", 3, "click"], [1, "col-md-12", "text-center"], ["pButton", "", "pRipple", "", "type", "button", "label", "FINISH", 1, "p-button-success", "pa-next-btn", 3, "click"]], template: function PaLoadComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div");
        i0.ɵɵelement(2, "img", 1);
        i0.ɵɵtemplate(3, PaLoadComponent_div_3_Template, 15, 7, "div", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.category);
    } }, directives: [i5$1.NgIf, i4$1.Accordion, i4$1.AccordionTab, i5$2.Tree, i3$1.ButtonDirective], styles: [".review-pa[_ngcontent-%COMP%]{font-size:24px;color:#4d97f3;text-transform:capitalize}.review-index[_ngcontent-%COMP%], .review-pa[_ngcontent-%COMP%]{text-align:center!important;padding:10px 0}.review-index[_ngcontent-%COMP%]{font-size:22px;color:#9e9e9e!important}.img-responsive[_ngcontent-%COMP%]{display:block;margin-left:auto;margin-right:auto}.checking[_ngcontent-%COMP%]{background-color:#000}.pa-next-btn[_ngcontent-%COMP%]{font-weight:500;border:2px solid #2196f3}.pa-next-btn[_ngcontent-%COMP%]   .pi-chevron-circle-right[_ngcontent-%COMP%]:before{background:#19a0da;color:#fff;border-radius:10px;font-size:23px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaLoadComponent, [{
        type: Component,
        args: [{
                selector: 'app-pa-load',
                templateUrl: './pa-load.component.html',
                styleUrls: ['./pa-load.component.scss']
            }]
    }], function () { return [{ type: PetitionAnalysisService }, { type: i2.DynamicDialogRef }, { type: i2.DynamicDialogConfig }]; }, { closebutton: [{
            type: ViewChild,
            args: ['closebutton']
        }] }); })();

const _c0 = function (a0, a1) { return { "pl-5": a0, "pr-5": a1 }; };
const _c1 = function (a0) { return { "width": a0 }; };
const _c2 = function (a0, a1) { return { "left": a0, "width": a1 }; };
function PaOverallComponent_div_45_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementStart(3, "span", 35);
    i0.ɵɵlistener("click", function PaOverallComponent_div_45_Template_span_click_3_listener() { i0.ɵɵrestoreView(_r8); const category_r5 = ctx.$implicit; const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.handlePaCategorized(category_r5); });
    i0.ɵɵtext(4, "Check details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 36);
    i0.ɵɵelement(6, "div", 37);
    i0.ɵɵelement(7, "div", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "span", 39);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c0, i_r6 % 2 !== 0, i_r6 % 2 === 0));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", category_r5.name, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(9, _c1, category_r5.successPercentage + "%"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction2(11, _c2, category_r5.successPercentage + "%", category_r5.failurePercentage + "%"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", category_r5.success, " / ", category_r5.total, "");
} }
function PaOverallComponent_ng_template_54_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-checkbox", 40);
    i0.ɵɵlistener("ngModelChange", function PaOverallComponent_ng_template_54_Template_p_checkbox_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.selectAllObservations = $event; })("onChange", function PaOverallComponent_ng_template_54_Template_p_checkbox_onChange_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.handleSelectAll(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngModel", ctx_r1.selectAllObservations)("binary", true);
} }
function PaOverallComponent_ng_template_58_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 41);
    i0.ɵɵelement(1, "th", 42);
    i0.ɵɵelementStart(2, "th");
    i0.ɵɵtext(3, "Petition Element");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "th", 43);
    i0.ɵɵtext(5, "Findings");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "th", 43);
    i0.ɵɵtext(7, "Recommendations");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9, "Status");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function PaOverallComponent_ng_template_59_p_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, " Needs to be fixed ");
    i0.ɵɵelementEnd();
} }
function PaOverallComponent_ng_template_59_p_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, " Looks Perfect ");
    i0.ɵɵelementEnd();
} }
function PaOverallComponent_ng_template_59_p_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, " Not Applicable ");
    i0.ɵɵelementEnd();
} }
function PaOverallComponent_ng_template_59_p_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, " Not Initiated ");
    i0.ɵɵelementEnd();
} }
function PaOverallComponent_ng_template_59_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 44);
    i0.ɵɵelement(2, "button", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 46);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 46);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 47);
    i0.ɵɵtemplate(10, PaOverallComponent_ng_template_59_p_10_Template, 2, 0, "p", 48);
    i0.ɵɵtemplate(11, PaOverallComponent_ng_template_59_p_11_Template, 2, 0, "p", 48);
    i0.ɵɵtemplate(12, PaOverallComponent_ng_template_59_p_12_Template, 2, 0, "p", 48);
    i0.ɵɵtemplate(13, PaOverallComponent_ng_template_59_p_13_Template, 2, 0, "p", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const obervation_r12 = ctx.$implicit;
    const expanded_r13 = ctx.expanded;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pRowToggler", obervation_r12)("icon", expanded_r13 ? "pi pi-chevron-up" : "pi pi-chevron-down");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(obervation_r12.elementName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(obervation_r12.finding);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(obervation_r12.recommendation);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", obervation_r12.status === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", obervation_r12.status === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", obervation_r12.status === 2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", obervation_r12.status === 3);
} }
function PaOverallComponent_ng_template_60_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 49);
    i0.ɵɵelementStart(1, "td", 50);
    i0.ɵɵelementStart(2, "div", 51);
    i0.ɵɵelementStart(3, "h6");
    i0.ɵɵtext(4, "Findings");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "h6");
    i0.ɵɵtext(8, "Recommendation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const obervation_r18 = ctx.$implicit;
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", obervation_r18.finding, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1("", obervation_r18.recommendation, " ");
} }
const _c3 = function () { return [25, 50, 100]; };
class PaOverallComponent {
    constructor(pAService, utilityPAService) {
        this.pAService = pAService;
        this.utilityPAService = utilityPAService;
        this.observations = [];
        this.backUpObservations = [];
        this.selObservationFilterCtg = [];
        this.selectAllObservations = true;
        this.observationCategories = [
            { name: 'Needs to be fixed', code: 0 },
            { name: 'Looks Perfect', code: 1 },
            { name: 'Not Applicable', code: 2 },
            { name: 'Not Initiated', code: 3 }
        ];
        this.onCheckDetailsClick = new EventEmitter();
        this.petitionId = parseInt(sessionStorage.getItem('petitionId'));
    }
    ngOnInit() {
        this.getPetitionAnalysis();
        this.handleSelectAll();
    }
    refreshPA() {
        this.pAService.generateAnalysis(this.petitionId).subscribe(() => {
            this.getPetitionAnalysis();
        });
    }
    getPetitionAnalysis() {
        this.pAService.getPetitionAnalysisStatus(this.petitionId).subscribe((response) => {
            if (response && response.status === 200) {
                this.getCategoryList();
                this.getSummary();
                this.getObservationSummery();
            }
        });
    }
    getObservationSummery() {
        this.pAService.getCategoryObervation(this.petitionId)
            .subscribe((response) => {
            this.utilityPAService.setObservationList(response.map((x, i) => {
                return Object.assign(Object.assign({}, x), { indexId: i });
            }));
            this.observations = this.utilityPAService.getObservationList();
        });
    }
    getSummary() {
        this.pAService.getSummery(this.petitionId).subscribe((response) => {
            if (response && response.status === 200) {
                this.summaryDetails = response.data;
            }
            else {
                this.summaryDetails = null;
            }
            this.summeryGraphDetails = Object.assign({}, {
                labels: [`${Math.round(((100 * this.summaryDetails.success) / this.summaryDetails.total))}% Looks Perfect`,
                    `${Math.round(((100 * this.summaryDetails.failure) / this.summaryDetails.total))}% Needs to be fixed`,
                    `${Math.round(((100 * this.summaryDetails.notinitiated) / this.summaryDetails.total))}% Not Initiated`,
                    `${Math.round(((100 * this.summaryDetails.na) / this.summaryDetails.total))}% Not Applicable`],
                datasets: [
                    {
                        data: [
                            Math.round((100 * this.summaryDetails.success) / this.summaryDetails.total),
                            Math.round((100 * this.summaryDetails.failure) / this.summaryDetails.total),
                            Math.round((100 * this.summaryDetails.notinitiated) / this.summaryDetails.total),
                            Math.round((100 * this.summaryDetails.na) / this.summaryDetails.total)
                        ],
                        backgroundColor: [
                            "#03A0DA",
                            "#FF8800",
                            "#A3A6B4",
                            "#E1E1E1"
                        ],
                        hoverBackgroundColor: [
                            "#03A0DA",
                            "#FF8800",
                            "#A3A6B4",
                            "#E1E1E1"
                        ]
                    }
                ]
            });
        });
    }
    getCategoryList() {
        this.pAService.getCategorySummary(this.petitionId).subscribe((response) => {
            if (response && response.status === 200) {
                this.categoryDetails = response.data;
            }
            else {
                this.categoryDetails = null;
            }
            this.categoryList = this.categoryDetails.map(x => {
                x['successPercentage'] = parseInt(((100 * x.success) / x.total).toString(), 10);
                x['failurePercentage'] = parseInt(((100 * x.failure) / x.total).toString(), 10);
                return x;
            });
        });
    }
    handlePaCategorized(category) {
        this.utilityPAService.categoryCode = category.code;
        this.utilityPAService.categoryName = category.name;
        this.onCheckDetailsClick.emit({ code: category.code });
    }
    handleFilter() {
        if (this.selObservationFilterCtg && this.selObservationFilterCtg.length > 0) {
            this.observations = this.utilityPAService.getObservationList().filter((x) => {
                if (this.selObservationFilterCtg.includes(x.status)) {
                    return true;
                }
            });
        }
        else {
            this.observations = [];
        }
        this.togglleAllFilter();
    }
    togglleAllFilter() {
        this.selectAllObservations = this.selObservationFilterCtg.length === this.observationCategories.length ? true : false;
    }
    handleSelectAll() {
        this.selObservationFilterCtg = this.selectAllObservations ? this.observationCategories.map(x => x.code) : [];
        this.handleFilter();
    }
}
PaOverallComponent.ɵfac = function PaOverallComponent_Factory(t) { return new (t || PaOverallComponent)(i0.ɵɵdirectiveInject(PetitionAnalysisService), i0.ɵɵdirectiveInject(PAUtility)); };
PaOverallComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PaOverallComponent, selectors: [["app-pa-overall"]], outputs: { onCheckDetailsClick: "onCheckDetailsClick" }, decls: 61, vars: 13, consts: [[1, "fluid-container"], [1, "row", "col-md-12", "pa-title"], [1, "col-md-10", "mb-3"], [1, "col-md-2", "mb-3"], ["type", "button", 1, "p-button-secondary", "p-button-lg", "pull-right", 3, "click"], [1, "pi", "pi-refresh", 2, "margin-right", "5px"], [1, "row", "col-md-12", "pa-status"], [1, "col-md-4"], [1, "pa-brd"], [1, "col-md-12"], [3, "inputData"], [1, "col-md-8"], [1, "row", "col-md-12", "pr-0", "pl-0"], [1, "row", "col-md-8", "pa-color"], [1, "ml-auto"], [1, "mr-3", "float-left"], [1, "float-left", "mr-1", "legend", "blue"], [1, "float-left"], [1, "float-left", "mr-1", "legend", "yellow"], [1, "float-left", "mr-1", "legend", "notInitiatedColor"], [1, "float-left", "mr-1", "legend", "notApplicableColor"], [1, "row", "col-md-12", "pt-4"], ["class", "col-md-6 pb-3", 3, "ngClass", 4, "ngFor", "ngForOf"], [1, "row", "mt-3", "col-md-12", "pa-status"], [1, "col-md-12", "row", 2, "height", "50px"], [1, "col-md-10", "row", "align-items-center"], [1, "col-md-2"], ["optionValue", "code", "defaultLabel", "Filter", "optionLabel", "name", 1, "filter-check", 3, "displaySelectedLabel", "filter", "showToggleAll", "options", "ngModel", "ngModelChange", "onChange"], ["pTemplate", "header"], [1, "col-md-12", "pl-0"], [1, "col", "px-1", "task-table"], ["styleClass", "p-datatable-gridlines", "rowExpandMode", "single", "currentPageReportTemplate", "Showing {first} to {last} of {totalRecords} entries", "dataKey", "indexId", 1, "pa-table", "im-card-no-border-table", "im-card-table-noborder-spacing", "table", 3, "paginator", "rows", "showCurrentPageReport", "rowsPerPageOptions", "value"], ["pTemplate", "body"], ["pTemplate", "rowexpansion"], [1, "col-md-6", "pb-3", 3, "ngClass"], [1, "pull-right", 3, "click"], [1, "grey"], [1, "green", 3, "ngStyle"], [1, "red", 3, "ngStyle"], [2, "color", "#C5C5C5"], ["label", "All Observations", "value", "afsdf", 1, "filter-all-select", 3, "ngModel", "binary", "ngModelChange", "onChange"], [1, "text-uppercase"], [2, "width", "3rem"], ["colspan", "2"], [2, "padding-top", "6px!important"], ["type", "button", "pButton", "", "pRipple", "", 1, "p-button-text", "p-button-rounded", "p-button-plain", 3, "pRowToggler", "icon"], ["colspan", "2", 1, "text-truncate"], [1, "text-truncate"], [4, "ngIf"], [1, "pt-5", "pt-5"], ["colspan", "7"], [1, "p-p-3", "rowExpansionData"]], template: function PaOverallComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h5");
        i0.ɵɵtext(4, "Petition Analysis");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelementStart(6, "p-button", 4);
        i0.ɵɵlistener("click", function PaOverallComponent_Template_p_button_click_6_listener() { return ctx.refreshPA(); });
        i0.ɵɵelement(7, "i", 5);
        i0.ɵɵtext(8, " Refresh ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵelementStart(10, "div", 7);
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵelementStart(12, "h6");
        i0.ɵɵtext(13, "Petition Status ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 9);
        i0.ɵɵelement(15, "img-primeng-donut", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 11);
        i0.ɵɵelementStart(17, "div", 8);
        i0.ɵɵelementStart(18, "div", 12);
        i0.ɵɵelementStart(19, "div", 7);
        i0.ɵɵelementStart(20, "h6");
        i0.ɵɵtext(21, "Each Category Level Analysis ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(22, "div", 13);
        i0.ɵɵelementStart(23, "div", 14);
        i0.ɵɵelementStart(24, "div", 15);
        i0.ɵɵelement(25, "div", 16);
        i0.ɵɵelementStart(26, "div", 17);
        i0.ɵɵelementStart(27, "span");
        i0.ɵɵtext(28, "Looks Perfect");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(29, "div", 15);
        i0.ɵɵelement(30, "div", 18);
        i0.ɵɵelementStart(31, "div", 17);
        i0.ɵɵelementStart(32, "span");
        i0.ɵɵtext(33, "Needs to be fixed");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "div", 15);
        i0.ɵɵelement(35, "div", 19);
        i0.ɵɵelementStart(36, "div", 17);
        i0.ɵɵelementStart(37, "span");
        i0.ɵɵtext(38, "Not Initiated");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(39, "div", 17);
        i0.ɵɵelement(40, "div", 20);
        i0.ɵɵelementStart(41, "div", 17);
        i0.ɵɵelementStart(42, "span");
        i0.ɵɵtext(43, "Not Applicable");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(44, "div", 21);
        i0.ɵɵtemplate(45, PaOverallComponent_div_45_Template, 10, 14, "div", 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(46, "div", 23);
        i0.ɵɵelementStart(47, "div", 8);
        i0.ɵɵelementStart(48, "div", 24);
        i0.ɵɵelementStart(49, "div", 25);
        i0.ɵɵelementStart(50, "h6");
        i0.ɵɵtext(51, "Overall Observations");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(52, "div", 26);
        i0.ɵɵelementStart(53, "p-multiSelect", 27);
        i0.ɵɵlistener("ngModelChange", function PaOverallComponent_Template_p_multiSelect_ngModelChange_53_listener($event) { return ctx.selObservationFilterCtg = $event; })("onChange", function PaOverallComponent_Template_p_multiSelect_onChange_53_listener() { return ctx.handleFilter(); });
        i0.ɵɵtemplate(54, PaOverallComponent_ng_template_54_Template, 1, 2, "ng-template", 28);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(55, "div", 29);
        i0.ɵɵelementStart(56, "div", 30);
        i0.ɵɵelementStart(57, "p-table", 31);
        i0.ɵɵtemplate(58, PaOverallComponent_ng_template_58_Template, 10, 0, "ng-template", 28);
        i0.ɵɵtemplate(59, PaOverallComponent_ng_template_59_Template, 14, 9, "ng-template", 32);
        i0.ɵɵtemplate(60, PaOverallComponent_ng_template_60_Template, 11, 2, "ng-template", 33);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(15);
        i0.ɵɵproperty("inputData", ctx.summeryGraphDetails);
        i0.ɵɵadvance(30);
        i0.ɵɵproperty("ngForOf", ctx.categoryList);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("displaySelectedLabel", false)("filter", false)("showToggleAll", false)("options", ctx.observationCategories)("ngModel", ctx.selObservationFilterCtg);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("paginator", true)("rows", 25)("showCurrentPageReport", true)("rowsPerPageOptions", i0.ɵɵpureFunction0(12, _c3))("value", ctx.observations);
    } }, directives: [i3$1.Button, ImgPrimengDonutComponent, i5$1.NgForOf, i7.MultiSelect, i5.NgControlStatus, i5.NgModel, i8.PrimeTemplate, i9.Table, i5$1.NgClass, i5$1.NgStyle, i10.Checkbox, i3$1.ButtonDirective, i9.RowToggler, i5$1.NgIf], styles: [".pa-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#585858;font-size:20px;font-weight:600}.pa-title[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#03a0da;font-size:16px;font-weight:600}.pa-status[_ngcontent-%COMP%]   .pa-brd[_ngcontent-%COMP%]{border:1px solid #c6c6c6;width:100%;height:100%;padding:10px}.pa-status[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#888;font-size:20px}.pa-status[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#00a3db;font-size:22px;font-weight:500;cursor:pointer}.pa-status[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#03a0da;cursor:pointer;font-size:13px}.pa-status[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#757575;font-size:13px;margin-bottom:0}.grey[_ngcontent-%COMP%]{background-color:#c8c8c8;position:relative;height:20px;width:100%}.grey[_ngcontent-%COMP%]   .green[_ngcontent-%COMP%]{left:0;background-color:#03a0da}.grey[_ngcontent-%COMP%]   .green[_ngcontent-%COMP%], .grey[_ngcontent-%COMP%]   .red[_ngcontent-%COMP%]{position:absolute;height:100%;top:0;z-index:1}.grey[_ngcontent-%COMP%]   .red[_ngcontent-%COMP%]{background-color:#f80}.pa-color[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:15px;margin-bottom:0;color:#a3a6b4}.pa-color[_ngcontent-%COMP%]   .legend[_ngcontent-%COMP%]{height:20px;width:20px}.pa-color[_ngcontent-%COMP%]   .blue[_ngcontent-%COMP%]{background-color:#03a0da}.pa-color[_ngcontent-%COMP%]   .yellow[_ngcontent-%COMP%]{background-color:#f80}.pa-color[_ngcontent-%COMP%]   .notInitiatedColor[_ngcontent-%COMP%]{background-color:#c8c8c8}.pa-color[_ngcontent-%COMP%]   .notApplicableColor[_ngcontent-%COMP%]{background-color:#a3a6b4}.brd-right[_ngcontent-%COMP%]{border-right:1px solid #c6c6c6}.pa-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;border-bottom:2px solid #dee2e6;padding:15px!important;color:#4d4f5c;font-style:normal;font-variant:normal;font-weight:700;font-size:13px}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{color:#888;border-top:none!important;padding:15px 15px 0!important;font-size:13px}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:6px 8px!important}.mat-table[_ngcontent-%COMP%]   .mat-header-row[_ngcontent-%COMP%]{height:45px}table.mat-table[_ngcontent-%COMP%]{border-spacing:0}tr.mat-footer-row[_ngcontent-%COMP%], tr.mat-row[_ngcontent-%COMP%]{height:48px}.rowExpansionData[_ngcontent-%COMP%]{width:93%;margin:0 auto;padding:5px 0}.rowExpansionData[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#4d4f5c;font-size:12px;font-style:normal;font-variant:normal;font-weight:700;text-transform:uppercase}.rowExpansionData[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#888;font-size:13px;padding-bottom:20px}.p-multiselect-close[_ngcontent-%COMP%], [_nghost-%COMP%]     .p-multiselect-close-override{visibility:hidden!important}"], data: { animation: [
            trigger('rowExpansionTrigger', [
                state('void', style({
                    transform: 'translateX(-10%)',
                    opacity: 0
                })),
                state('active', style({
                    transform: 'translateX(0)',
                    opacity: 1
                })),
                transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
            ])
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PaOverallComponent, [{
        type: Component,
        args: [{
                selector: 'app-pa-overall',
                templateUrl: './pa-overall.component.html',
                styleUrls: ['./pa-overall.component.scss'],
                animations: [
                    trigger('rowExpansionTrigger', [
                        state('void', style({
                            transform: 'translateX(-10%)',
                            opacity: 0
                        })),
                        state('active', style({
                            transform: 'translateX(0)',
                            opacity: 1
                        })),
                        transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
                    ])
                ]
            }]
    }], function () { return [{ type: PetitionAnalysisService }, { type: PAUtility }]; }, { onCheckDetailsClick: [{
            type: Output
        }] }); })();

class PetitionAnalysisLibraryModule {
}
PetitionAnalysisLibraryModule.ɵfac = function PetitionAnalysisLibraryModule_Factory(t) { return new (t || PetitionAnalysisLibraryModule)(); };
PetitionAnalysisLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: PetitionAnalysisLibraryModule });
PetitionAnalysisLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(PetitionAnalysisLibraryModule, { declarations: [ImgPrimengDonutComponent,
        PaOverallComponent,
        PaLoadComponent,
        PaCategorizedComponent], imports: [PrimengLibraryModule], exports: [ImgPrimengDonutComponent,
        PaOverallComponent,
        PaLoadComponent,
        PaCategorizedComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PetitionAnalysisLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ImgPrimengDonutComponent,
                    PaOverallComponent,
                    PaLoadComponent,
                    PaCategorizedComponent
                ],
                imports: [
                    PrimengLibraryModule
                ],
                exports: [
                    ImgPrimengDonutComponent,
                    PaOverallComponent,
                    PaLoadComponent,
                    PaCategorizedComponent
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of petition-analysis-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ImgPrimengDonutComponent, PAUtility, PaCategorizedComponent, PaLoadComponent, PaOverallComponent, PetitionAnalysisLibraryModule, PetitionAnalysisService };
//# sourceMappingURL=petition-analysis-library.js.map
